let defaultStateValue = {
    adminDashboardRequestsNotifCount: 0, adminResCenterNotifCount: 0, ptPlusRequestsOrderCount: 0, orderChatCount: 0,
}

export default (state = defaultStateValue, action) => {
    switch (action.type) {
        case "NOTIFICATION_COUNT_ADMIN_DASHBOARD_USER_REQUEST":
            return { ...state, adminDashboardRequestsNotifCount: action.payload };
        case "NOTIFICATION_COUNT_ADMIN_RES_CENTER":
            return { ...state, adminResCenterNotifCount: action.payload };
        case "NOTIFICATION_COUNT_REQUEST_ORDERS":
            return { ...state, ptPlusRequestsOrderCount: action.payload };
        case "NOTIFICATION_COUNT_ORDER_CHAT":
            return { ...state, orderChatCount: action.payload };
        default:
            return state;
    }
};